import { useQuery } from "@tanstack/react-query";
import { tournamentGoalkeepersLeaderboardQueryOptions } from "@/api/tournamentAnalysis";
import { followedPlayerIdsQueryOptions } from "@/api/followedPlayers";
import { useTournamentContext } from "../page";
import { ScoutingGoalkeepersTable } from "@/components/general/Scouting/ScoutingGoalkeepersTable";
import type { StatCategory } from "@/components/general/Scouting/ScoutingGoalkeepersTable";

export const TournamentGoalkeepersPage = () => {
    const { selectedTournamentId, tournaments, statCategory } = useTournamentContext();
    const isTournamentsLoading = tournaments === undefined;

    const { data: followedPlayerIds } = useQuery(followedPlayerIdsQueryOptions());

    const { data: tournamentGoalkeepersData, isLoading: tournamentGoalkeepersLoading } = useQuery({
        ...tournamentGoalkeepersLeaderboardQueryOptions(selectedTournamentId || 0),
        enabled: !!selectedTournamentId && selectedTournamentId > 0,
    });

    const goalkeeperCategory: StatCategory =
        statCategory === "overview" ||
        statCategory === "performance" ||
        statCategory === "passing" ||
        statCategory === "screens"
            ? statCategory
            : "overview";

    return (
        <div className="flex-1 min-h-0 h-full flex flex-col rounded-md overflow-hidden border-table-border-color">
            <ScoutingGoalkeepersTable
                data={tournamentGoalkeepersData?.goalKeepers || []}
                isLoading={tournamentGoalkeepersLoading || isTournamentsLoading}
                selectedCategory={goalkeeperCategory}
                followedPlayerIds={followedPlayerIds}
            />
        </div>
    );
};
